// extracted by mini-css-extract-plugin
export var root = "InfoGraphicCard-module--root--K9WW4";
export var text = "InfoGraphicCard-module--text--X5F1l";
export var title = "InfoGraphicCard-module--title--HxV0n";